import styled from 'styled-components';

export const Main = styled.div`
  ${props => props.videoLoaded && 'background-color: white;'}
  position: relative;
  height: calc(93vh - 24px);
`;
